import { useState } from 'react'

import type { TimelineKind } from '@/api/types'
import { PageHeader } from '@/app/layouts/PageHeader'
import { PostList } from '@/features/posts'
import { KindFilter, useExploreTimeline } from '@/features/timeline'
import { TrendsList } from '@/features/trends'
import { useT } from '@/i18n'

export function ExplorePage() {
  const t = useT()
  const [kind, setKind] = useState<TimelineKind>('all')
  const timeline = useExploreTimeline(kind)

  return (
    <>
      <PageHeader title={t('nav.explore')} subtitle={t('explore.subtitle')}>
        <div className="pt-1">
          <KindFilter value={kind} onChange={setKind} />
        </div>
      </PageHeader>
      {/* 窄屏没有右栏，趋势放到探索页顶上 */}
      <TrendsList limit={5} compact className="border-b border-line lg:hidden" />
      <PostList query={timeline} emptyTitle={t('explore.empty')} />
    </>
  )
}
